import React from "react";

const Header = ({ title }) => (
    <header className="welcome-header">
        <h1>{ title || "Programmeerimise algkursus (ITI0102)" }
        </h1>
    </header>
);

export default Header;
